<template>
  <v-scale-transition>
    <kits-panel :kits-items="dmtReports">
      <h3 class="headline grey--text text-xs-center hidden-sm-and-down">
        User Statistics
      </h3>
    </kits-panel>
  </v-scale-transition>
</template>

<script>
export default {
  components: {
    KitsPanel: () =>
      import(/* webpackChunkName: "kitsPanel" */ '@/components/KitsPanel'),
  },
  data () {
    return {}
  },
  computed: {
    dmtReports: function () {
      const menus = [
        {
          icon: 'mdi-calendar-blank-multiple',
          path: '/support/annual_user_statistics',
          title: 'Annual',
        },
        {
          icon: 'mdi-calendar-blank',
          path: '/support/monthly_user_statistics',
          title: 'Monthly',
        },
        {
          icon: 'mdi-calendar-account-outline',
          path: '/support/weekly_user_statistics',
          title: 'Weekly',
        },
        {
          icon: 'mdi-calendar-account-outline',
          path: '/support/monthly_sld_statistics',
          title: 'SLD Statistics',
        },
      ]

      return menus
    },
  },
}
</script>
